import React from "react";
import styles from "./b2b-hero.module.scss";
import { useTranslation } from "react-i18next";
import { FixButton } from "@/elements-react/fix-button";
import heroImagePlaceholder from "@/assets/Cart_2X.webp";
import {Icon} from "@/elements-react/fix-icon";
import businessClientIcon from "@/assets/business-client.svg";
import whatsappIcon from "@/assets/whatsapp.svg";
import {Url} from "@/helpers/url.ts";
import {useServices} from "@/services-context.tsx";
import {useCallback} from "preact/hooks";

export const B2bHero: React.FC = () => {
    const { t } = useTranslation();
    const { customerChannel, formatter } = useServices();

    const handleWhatsappClick = useCallback(() => {
        const encodedPhone = formatter.phoneCleaner(customerChannel.whatsappPhone!);

        window.open(`https://wa.me/${encodedPhone}`, "_blank");
    }, []);

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>
                {t("Order auto parts your business way")}
            </h1>
            <p className={styles.subtitle}>
                {t("Full control over stock, orders and deliveries with bulk uploads")}
                <span className={styles.subtitleHighlight}>{t("b2b-page.subtitle.highlight", " up to 700 items")}</span>
            </p>

            <div className={styles.actions}>
                <FixButton
                    variant="default"
                    className={styles.whatsappBtn}
                    onClick={handleWhatsappClick}
                    prefix={<Icon className={styles.icon} src={whatsappIcon} />}
                >
                    {t("Contact sales")}
                </FixButton>
                <FixButton
                    variant="primary"
                    className={styles.becomeBtn}
                    href={Url.to("signup-page")}
                    prefix={<Icon className={styles.icon} src={businessClientIcon} />}
                >
                    {t("Become a business customer")}
                </FixButton>
            </div>

            <div className={styles.imageContainer}>
                <img
                    src={heroImagePlaceholder}
                    alt={t("B2B Dashboard Interface")}
                    className={styles.heroImage}
                />
            </div>
        </div>
    );
};
